import {useEffect, useState} from "react";

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +targetDate - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Clear interval if the component is unmounted
    return () => clearInterval(timer);
  }, [targetDate]);

  const timerComponents = [];

  Object.keys(timeLeft).forEach(interval => {
    timerComponents.push(
        <div className="timer-section" key={interval}>
          {timeLeft[interval].toString().padStart(2, "0")}
          <div className="timer-label">{interval}</div>
        </div>
    );
  });

  return (
      <div className="timer">
        <div className="timer-header">Offer ends in</div>
        {timerComponents.length ? <div className="timer-row">{timerComponents}</div> : <span>Time's up!</span>}
      </div>
  );
};

export default CountdownTimer;
